export enum RunTypes {
  ARCHIVED_RUN = 'ARCHIVED_RUN'
}
